import React from 'react';
import classNames from 'classnames';
import { spaceless } from '../../../utils/strings';
import PropTypes from 'prop-types';
import { Modal as AncestryModal } from 'ancestry-ui-react';

export default function Modal({ close, visible, classes, title, width, closeOnBkgClick, children }) {
  if (!visible) return null;

  const className = classNames(spaceless(`boards-modal ${classes}`), {
    visible
  });

  return (
    <AncestryModal
      title={title}
      open
      hideCloseBtn={!close}
      closeOnBkgClick={closeOnBkgClick}
      onClose={close}
      width={width}
    >
      <div className={className}>
        {children}
      </div>
    </AncestryModal>
  );
}

Modal.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  classes: PropTypes.string,
  visible: PropTypes.bool,
  closeOnBkgClick: PropTypes.bool,
  width: PropTypes.number,
  close: PropTypes.func
};

Modal.defaultProps = {
  title: '',
  classes: '',
  visible: true,
  closeOnBkgClick: false,
  width: 400,
  close: () => {}
};
